export default __webpack_public_path__ + "static/media/skip-video-arrow.f4f095b8.svg";